import $ from 'jquery' // jQuery

import './module/_hashScroll' // アンカーリンクスクロール
import './module/_spMenuToggle' // SPメニュー開閉

/* global  */ // tUrl等のグローバル変数を宣言する

import './_top.js'
// import './_form.js'

// import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
// Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

/*
#### ##    ## ########          #######  ########   ######
 ##  ####  ##    ##            ##     ## ##     ## ##
 ##  ## ## ##    ##    ####### ##     ## ########   ######
 ##  ##  ####    ##            ##     ## ##     ##       ##
#### ##    ##    ##             #######  ########   ######
*/
// 画面に入った監視対象に.activeを付加
// Intersection Observer
window.intObs = function (rootMargin) {
  if (!document.getElementsByClassName('js-in')[0]) {
    return
  }
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: '-20%', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-in')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      if (entry.isIntersecting) {
        const entryItem = entry.target
        entryItem.classList.add('active')
        observer.unobserve(entryItem) // 監視対象から外す
      }
    }
  }
}

if (!document.getElementById('page-top')) {
  window.intObs('-10% 0px')
} else {
  window.intObs('-50% 0px')
}

/*
 ######   ######          ##    ##    ###    ##     ##
##       ##               ####  ##  ##   ##  ##     ##
 ######  ##       ####### ## ## ## ##     ## ##     ##
      ## ##               ##  #### #########  ##   ##
 ######   ######          ##    ## ##     ##    ###

ターゲットが走査線に入ったら連動する要素にクラスを当てる
Intersection Observer APIを使用

<a href="#hoge" class="js-scrollNav js-scrollNav--hoge"></a>
<section id="hoge" class="js-scrollNav-trigger" data-nav-target="hoge">
  section#hogeが画面に入ったらjs-scrollNav--hogeにクラスを当てる
</section>
*/

if (document.getElementsByClassName('js-scrollNav')[0]) {
  scrollNav()
}
function scrollNav() {
  const navItems = document.getElementsByClassName('js-scrollNav')
  const intObsOption = {
    rootMargin: '-50% 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(scrollNavCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-scrollNav-trigger')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function scrollNavCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      // 接触アイテムを発見
      if (entry.isIntersecting) {
        // 全ての.activeを外す
        for (let index = 0; index < navItems.length; index++) {
          navItems[index].classList.remove('current')
        }
        const entryItem = entry.target
        const target = entryItem.dataset.navTarget // 制御対象名を取得

        // 対象アイテムをアクティブにする
        const targetItems = document.getElementsByClassName('js-scrollNav--' + target)
        for (let index = 0; index < targetItems.length; index++) {
          const targetItem = targetItems[index]
          targetItem.classList.add('current')
        }
        break // 以降の判定は飛ばす
      }
    }
  }
}

//目次
if (document.getElementsByClassName('toc_title')[0]) {
  let toc_title = document.querySelector('.toc_title')
  toc_title.addEventListener('click', function processEvent(e) {
    if (toc_title.classList.contains('act')) {
      e.target.classList.remove('act')
      toc_title.parentElement.classList.remove('active')
    } else {
      e.target.classList.add('act')
      toc_title.parentNode.classList.add('active')
    }
  })
}

document.addEventListener('click', function handleClick(e) {
  console.log('clicked: ', e.target.className)
})

// アコーディオン
document.addEventListener('DOMContentLoaded', function () {
  const accordionTitle = document.querySelectorAll('.js__accordion')
  for (let i = 0; i < accordionTitle.length; i++) {
    accordionTitle[i].addEventListener('click', function () {
      this.classList.toggle('active')
      this.previousElementSibling.classList.toggle('open')
      window.scrollTo({ top: this.closest('.job__box').offsetTop + 600, behavior: 'smooth' })
    })
  }
})

// よくある質問
const faqTitle = document.querySelectorAll('.js_ttl')

faqTitle.forEach((button) => {
  button.addEventListener('click', () => {
    const para = button.nextElementSibling
    const icon = button.children[1]

    para.classList.toggle('show')
    icon.classList.toggle('rotate')
  })
})

$(function () {
  $('.js-fluid').hover(
    function () {
      $(this).addClass('wide')
      $('.js-fluid').not(this).addClass('narrow')
    },
    function () {
      $(this).removeClass('wide')
      $('.js-fluid').not(this).removeClass('narrow')
    }
  )
})

// Back to top
$(function () {
  var back2top = $('.back2top')
  back2top.hide()
  $(window).on('scroll', function () {
    if ($(this).scrollTop() > 100) {
      back2top.fadeIn()
    } else {
      back2top.fadeOut()
    }
  })
  back2top.on('click', function (e) {
    e.preventDefault()
    $('html, body').animate({ scrollTop: 0 }, 500)
  })
})
